import { gaps, paddings } from '@ohgoodlord/design-system'
import styled from 'styled-components'

const StyledFooter = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  width: 100%;
  justify-self: flex-end;
  flex-direction: row-reverse;
  justify-content: space-between;
  gap: ${gaps.s};
  text-align: left;
  background-color: #ffffff;
  border-top: 1px solid #e0e0e0;
  padding: ${paddings.m};
`

export interface Props {
  renderActions: () => JSX.Element
}

export const DefaultFooter = ({ renderActions }: Props) => (
  <StyledFooter>{renderActions()}</StyledFooter>
)
